import {Injectable} from '@angular/core';
import {ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {Signal} from '@models/dashboard/signal';
import {TranslationService} from '@services/translation/translation.service';

@Injectable({
  providedIn: 'root'
})
export class GaugeChartSeriesSettingsGeneratorService {

  constructor(private translationService: TranslationService) {}

  public generateSeries(gaugeType: string, signal: ChartSignalEntry, machineSignal: Signal, data: any): any[] {

    let decimalPlaces = 1;
    let unit = signal.unit;
    let label = signal.displayedText;
    let id = Number(signal.signalId);
    let signalName = signal.signalName;
    if (this.isDefined(machineSignal)) {
      decimalPlaces = machineSignal.decimals;
      unit = machineSignal.unit || unit;
      label = machineSignal.label || label;
      id = machineSignal.id || id;
      signalName = machineSignal.signal || signalName;
    }
    label = this.translationService.translate.instant(label);

    return [{
      id: String(id),
      data: [this.toInitialValue(data)],
      signalName: signalName,
      name: label,
      dataLabels: {
        format: this.generateDataLabel(gaugeType, decimalPlaces, unit)
      },
      marker: {
        symbol: 'circle',
        enabled: false
      }
    }];

  }

  private generateDataLabel(gaugeType, decimalPlaces, unit): string {

    let dataLabel;
    if (gaugeType === 'gauge') {
      dataLabel = '{y:.' + decimalPlaces + 'f}';
    } else {
      dataLabel = '<div class="solid-gauge-data gauge-series-format"><span class="gauge-value">{y:.' + decimalPlaces + 'f}</span> ' +
          '<span class="gauge-unit">' + unit + '</span></div>';
    }
    return dataLabel;
  }

  private isDefined(value) {
    return typeof value !== 'undefined';
  }

  private toInitialValue(data: any): number | null {
    if (data === null || data === undefined) {
      return null;
    }
    if (Array.isArray(data) && data.length > 0 && data[data.length - 1]?.vs?.[0]?.v !== undefined) {
      const numeric = Number(data[data.length - 1].vs[0].v);
      return isNaN(numeric) ? null : numeric;
    }
    const numeric = Number(data);
    return isNaN(numeric) ? null : numeric;
  }

}
